import moment from 'moment';

export function getToday() {
  return moment()._d;
}

export function formatDateToSql(date) {
  return moment(date).format('DD/MM/yyyy');
}
